import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_systemDefaultFixedWidthFont14cv3wy0prdkq as get_systemDefaultFixedWidthFont,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import { Jsonsmkyu9xjl7fv as Json } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import {
  Companion_instance17v8p6g2424o4 as Companion_instance,
  Companion_instancegwok6qx7et5m as Companion_instance_0,
  get_kind27kjvyfnc9an8 as get_kind,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator1qrulkrel7e5m as Generator,
  Generator2kgtccb0jt0mi as Generator_0,
} from './FormRenderer.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function JsonRenderer$json$lambda($this$Json) {
  $this$Json.q28_1 = true;
  $this$Json.a29_1 = true;
  $this$Json.o28_1 = true;
  return Unit_instance;
}
var JsonRenderer$view$2$$inlined$invoke$1Class;
function JsonRenderer$view$2$$inlined$invoke$1() {
  if (JsonRenderer$view$2$$inlined$invoke$1Class === VOID) {
    class $ {
      hd1(theme) {
        return theme.yd1(theme.gb0_1.fd1(get_systemDefaultFixedWidthFont())).cb1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    JsonRenderer$view$2$$inlined$invoke$1Class = $;
  }
  return JsonRenderer$view$2$$inlined$invoke$1Class;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var JsonRenderer$form$2$$inlined$invoke$1Class;
function JsonRenderer$form$2$$inlined$invoke$1() {
  if (JsonRenderer$form$2$$inlined$invoke$1Class === VOID) {
    class $ {
      hd1(theme) {
        return theme.yd1(theme.gb0_1.fd1(get_systemDefaultFixedWidthFont())).cb1_1;
      }
    }
    protoOf($).abf = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    JsonRenderer$form$2$$inlined$invoke$1Class = $;
  }
  return JsonRenderer$form$2$$inlined$invoke$1Class;
}
var JsonRendererClass;
function JsonRenderer() {
  if (JsonRendererClass === VOID) {
    class $ {
      constructor() {
        JsonRenderer_instance = this;
        var tmp = this;
        var tmp_0 = get_DefaultJson();
        tmp.wdy_1 = Json(tmp_0, JsonRenderer$json$lambda);
        this.xdy_1 = 'JSON';
      }
      i20() {
        return this.xdy_1;
      }
      edu() {
        return 0.01;
      }
      pdu(module_0, selector) {
        var tmp = Companion_instance;
        return tmp.qdu(module_0, this, selector, VOID, VOID, ($this$ViewRenderer, _unused_var__etf5q3, it) => {
          // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
          Companion_getInstance();
          var tmp$ret$0 = new (JsonRenderer$view$2$$inlined$invoke$1())();
          var tmp = $this$ViewRenderer.jbb(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.gbb(p, view);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_content_$ref_4pzcwl(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$1 = JsonRenderer_getInstance().wdy_1.v27(selector.gdu_1, $this$reactiveScope.daj(it));
            this_0.set(tmp$ret$1);
            return Unit_instance;
          });
          $this$ViewRenderer.hbb(p, view);
          return $this$ViewRenderer.lbb(tmp, view);
        });
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        return tmp.odu(module_0, this, selector, VOID, VOID, ($this$FormRenderer, _unused_var__etf5q3, it) => {
          var tmp = sizeConstraints($this$FormRenderer, VOID, VOID, get_rem(20));
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = $this$FormRenderer.jbb(FieldSemantic_getInstance());
          var tmp_0 = $this$FormRenderer.kbb(tmp, tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
          Companion_getInstance();
          var tmp$ret$1 = new (JsonRenderer$form$2$$inlined$invoke$1())();
          var tmp_1 = $this$FormRenderer.kbb(tmp_0, $this$FormRenderer.jbb(tmp$ret$1));
          // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextArea())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.gbb(p, view);
          var tmp_2 = (it) => JsonRenderer_getInstance().wdy_1.v27(selector.gdu_1, it);
          view.zah(view.scl_1, it.dak(tmp_2, (o, it) => {
            var tmp;
            try {
              tmp = JsonRenderer_getInstance().wdy_1.w27(selector.gdu_1, it);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                tmp_0 = o;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          }));
          $this$FormRenderer.hbb(p, view);
          return $this$FormRenderer.lbb(tmp_1, view);
        });
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).h94 = get_type;
    protoOf($).rdu = get_nullable;
    protoOf($).sdu = get_annotation;
    protoOf($).wds = get_handlesField;
    protoOf($).kdu = size;
    protoOf($).tdu = priority;
    protoOf($).fdu = matches;
    initMetadataForObject($, 'JsonRenderer', VOID, VOID, [Generator(), Generator_0()]);
    JsonRendererClass = $;
  }
  return JsonRendererClass;
}
var JsonRenderer_instance;
function JsonRenderer_getInstance() {
  if (JsonRenderer_instance === VOID)
    new (JsonRenderer())();
  return JsonRenderer_instance;
}
//region block: exports
export {
  JsonRenderer_getInstance as JsonRenderer_getInstanceck93e7fofwux,
};
//endregion

//# sourceMappingURL=JsonRenderer.mjs.map
